import './SuccessDialogBody.less';

import React from 'react';
import CheckIcon from '../../icons/CheckIcon';
import { Button } from '../button/Button';
import i18n from '../../common/i18n';

// spravil som to pre podsunutie i18n codu, kedze uz pri prvom pouziti som to chcel zavolat z funkcie po prichode response kde kontext neviem pouzit
function SuccessDialogBody({
    i18nTitleCode,
    i18nTextCode,
    close
}: {
    i18nTitleCode: string;
    i18nTextCode: string;
    close?: () => void;
}) {
    return (
        <div className="text-center flex flex-col items-center pt-10 pb-30">
            <div className="sucess-dialog-body-sucess-icon flex-center">
                <CheckIcon width={40} height={40} />
            </div>

            {i18nTitleCode && <div className="fs-16 text-extra-bold pt-20">{i18n(i18nTitleCode)}</div>}
            {i18nTextCode && (
                <div className="sucess-dialog-body-text pt-10 c-black-50-2 fs-14">{i18n(i18nTextCode)}</div>
            )}
            <Button onClick={() => close()} primary label={i18n('nui.button.close')} className="nui-button-180" large />
        </div>
    );
}

export default SuccessDialogBody;
